import(/* webpackMode: "eager", webpackExports: ["Spin"] */ "__barrel_optimize__?names=Space,Spin!=!/home/vanxuan/project/vanxuan/web-user/node_modules/antd/es/index.js");
